import React from 'react';
import { ContenedorParametros } from '../components/utils/ContenedorParametros';


export const Historial = ()=>{

    
    return (
        <>
            <ContenedorParametros titulo='Historial'>

            </ContenedorParametros>
        </>
    )

}